import { type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { type InsightsMetricsMap, LensGranularity, type StatsItem } from "../models";

import { mapAverageValues } from "./mapAverageValues";
import { mapComputedTotalValues } from "./mapComputedTotalValues";
import { mapDiffValues } from "./mapDiffValues";
import { mapLifetimeTotalValues } from "./mapLifetimeTotalValues";

interface MapTotalAndDiffProps {
    metrics: InsightsMetricsMap<StatsItem>;
    metricsPrevious: InsightsMetricsMap<StatsItem>;
    lifetimeData: readonly MyLensesOrganicStatsResponseEntry[];
    selectedTimeRange: LensGranularity;
}

export const mapTotalAndDiffValues = ({
    metrics,
    metricsPrevious,
    lifetimeData,
    selectedTimeRange,
}: MapTotalAndDiffProps): InsightsMetricsMap<StatsItem> => {
    const metricsWithTotalValues = mapComputedTotalValues(metrics);
    const metricsWithAverageValues = mapAverageValues(metricsWithTotalValues);

    return selectedTimeRange === LensGranularity.Lifetime
        ? mapLifetimeTotalValues(metricsWithAverageValues, lifetimeData)
        : mapDiffValues(metricsWithAverageValues, metricsPrevious);
};
